import React, { useEffect, useState } from "react";
import { Modal, Row, Col, notification, Button, Skeleton, Divider, Tag } from "antd";
import moment from "moment";
import axios from "axios";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const labelSimNaoParcialmente = value => {
    if (value === "sim") return <Tag color="green">Sim</Tag>;
    if (value === "nao") return <Tag color="red">Não</Tag>;
    if (value === "parcialmente") return <Tag color="orange">Parcialmente</Tag>;
    return "-";
};

const parseArray = value => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
        return JSON.parse(value);
    } catch {
        return [];
    }
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const ModalPlanoAtendimento = ({ id, visible, onCancel, onDelete }) => {
    const [estudo, setEstudo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-estudo-infantil",
            params: { id }
        })
            .then(response => {
                const dados = response.data;

                const observacoesFamilia = parseObject(dados.observacoes_familia, {
                    observacoes_familia_relato: "",
                    observacoes_familia_estrategias: ""
                });

                const alinhamentoEscolaFamilia = parseObject(dados.alinhamento_escola_familia, {
                    familia_ciente_intervencoes: null,
                    familia_disponibilidade_parceria: null,
                    familia_atividades_terapias_externas: null,
                    familia_atividades_terapias_dias: [],
                    familia_atividades_terapias_quais: "",
                    combinado_escola_familia: ""
                });

                setEstudo({
                    ...dados,
                    adaptacao_escolar: parseArray(dados.adaptacao_escolar),
                    interacao_socializacao: parseArray(dados.interacao_socializacao),
                    comunicacao: parseArray(dados.comunicacao),
                    comportamento: parseArray(dados.comportamento),
                    rotina_autonomia: parseArray(dados.rotina_autonomia),
                    realizado_com_crianca: parseArray(dados.realizado_com_crianca),
                    data_registro: dados.data_registro ? moment(dados.data_registro) : null,

                    observacoes_familia_relato: observacoesFamilia.observacoes_familia_relato || "",
                    observacoes_familia_estrategias: observacoesFamilia.observacoes_familia_estrategias || "",

                    familia_ciente_intervencoes: alinhamentoEscolaFamilia.familia_ciente_intervencoes || null,
                    familia_disponibilidade_parceria: alinhamentoEscolaFamilia.familia_disponibilidade_parceria || null,
                    familia_atividades_terapias_externas: alinhamentoEscolaFamilia.familia_atividades_terapias_externas || null,
                    familia_atividades_terapias_dias: parseArray(alinhamentoEscolaFamilia.familia_atividades_terapias_dias),
                    familia_atividades_terapias_quais: alinhamentoEscolaFamilia.familia_atividades_terapias_quais || "",
                    combinado_escola_familia: alinhamentoEscolaFamilia.combinado_escola_familia || ""
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao carregar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const validarExcluir = () => {
        confirm({
            title: "Pretende remover este estudo de caso?",
            okText: "Confirmar",
            cancelText: "Cancelar",
            onOk: () => excluir()
        });
    };

    const excluir = () => {
        axios({
            method: "put",
            url: "/api/estudo-caso/excluir",
            params: { id }
        })
            .then(() => {
                openNotificationWithIcon("success", "Removido", "O estudo de caso foi removido com sucesso.");
                onDelete();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao excluir o estudo de caso.");
            });
    };

    useEffect(() => {
        if (id && visible) carregarDetalhe(id);
    }, [id]);

    const renderTags = arr =>
        arr && arr.length > 0
            ? arr.map(item => (
                  <Tag key={item} style={{ marginBottom: 4 }}>
                      {item}
                  </Tag>
              ))
            : "-";

    const renderField = (label, value, span = 12) => (
        <Col span={span}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                <p className="field-value">{value || "-"}</p>
            </Skeleton>
        </Col>
    );

    const renderFieldWide = (label, value) => (
        <Col span={24}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                <p className="field-value">{value || "-"}</p>
            </Skeleton>
        </Col>
    );

    const renderTagField = (label, arr) => (
        <Col span={24}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                <div style={{ marginTop: 4 }}>{renderTags(arr)}</div>
            </Skeleton>
        </Col>
    );
    return (
        <Modal
            title={
                <div>
                    <div style={{ fontWeight: "bold", fontSize: 16 }}>Estudo de caso</div>
                    <div style={{ fontSize: 12, color: "#888" }}>Visualização do estudo de caso diagnóstico</div>
                </div>
            }
            className="modal-detalhe-info"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Fechar
                </Button>,
                <Button key="eliminar" className="modal-detalhe-info-delete-btn" type="danger" onClick={validarExcluir}>
                    Excluir estudo
                </Button>
            ]}
            centered
            width={800}
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        >
            <div className="modal-detalhe-info__body">
                <div className="modal-detalhe-info__section">
                    {/* 1. Dados da criança */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        1. Dados da criança
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderField("Nome da criança", estudo?.nome_crianca, 24)}
                        {renderField("Turma/Ano", estudo?.turma_ano)}
                        {renderField("Idade", estudo?.idade)}
                        {renderField("Professor(a)", estudo?.professor)}
                        {renderField("Data", estudo?.data_registro ? estudo.data_registro.format("DD/MM/YYYY") : "-")}
                    </Row>

                    {/* 2. Adaptação Escolar */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        2. Adaptação Escolar
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("", estudo?.adaptacao_escolar)}
                    </Row>

                    {/* 3. Interação e Socialização */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        3. Interação e Socialização
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("", estudo?.interacao_socializacao)}
                    </Row>

                    {/* 4. Comunicação */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        4. Comunicação
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("", estudo?.comunicacao)}
                    </Row>

                    {/* 5. Comportamento */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        5. Comportamento
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("", estudo?.comportamento)}
                    </Row>

                    {/* 6. Rotina e Autonomia */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        6. Rotina e Autonomia
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("", estudo?.rotina_autonomia)}
                    </Row>

                    {/* 7. O que já foi realizado com a criança */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        7. O que já foi realizado com a criança
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderTagField("", estudo?.realizado_com_crianca)}
                    </Row>

                    {/* 8. O que funciona melhor */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        8. O que funciona melhor
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide("Descrição", estudo?.funciona_melhor)}
                    </Row>

                    {/* 9. O que precisa ser trabalhado */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        9. O que precisa ser trabalhado
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide("Descrição", estudo?.precisa_trabalhado)}
                    </Row>

                    {/* 10. Observações da família */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        10. Observações da família
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide(
                            "Relato sobre o desenvolvimento da criança e principais preocupações da família",
                            estudo?.observacoes_familia_relato
                        )}
                        {renderFieldWide(
                            "O que a família considera que ajuda a criança a aprender melhor",
                            estudo?.observacoes_familia_estrategias
                        )}
                    </Row>

                    {/* Alinhamento Escola e Familiar */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        Alinhamento Escola e Familiar
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        <Col span={24} style={{ marginBottom: 8 }}>
                            <span className="field-label">A família está ciente das intervenções pedagógicas</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>{labelSimNaoParcialmente(estudo?.familia_ciente_intervencoes)}</div>
                            </Skeleton>
                        </Col>
                        <Col span={24} style={{ marginBottom: 8 }}>
                            <span className="field-label">A família demonstra disponibilidade para parceria com a escola</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>{labelSimNaoParcialmente(estudo?.familia_disponibilidade_parceria)}</div>
                            </Skeleton>
                        </Col>
                        <Col span={24} style={{ marginBottom: 8 }}>
                            <span className="field-label">A família leva a criança para atividades ou terapias externas</span>
                            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                                <div style={{ marginTop: 4 }}>{labelSimNaoParcialmente(estudo?.familia_atividades_terapias_externas)}</div>
                            </Skeleton>
                        </Col>

                        {estudo?.familia_atividades_terapias_externas === "sim" && (
                            <>
                                {renderTagField("Dias da semana", estudo?.familia_atividades_terapias_dias)}
                                {renderField("Quais:", estudo?.familia_atividades_terapias_quais, 24)}
                            </>
                        )}

                        {renderFieldWide("Combinado entre escola e família / orientações", estudo?.combinado_escola_familia)}
                    </Row>

                    {/* 11. Recomendações finais */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        11. Recomendações finais
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderFieldWide("Descrição", estudo?.recomendacoes_finais)}
                    </Row>
                </div>
            </div>
        </Modal>
    );
};

export default ModalPlanoAtendimento;
